import React, { Component } from 'react';
import AdminAPI from '../Api/account';
import Loading from './../Components/Loading';
import Launch from './Launch';
import Login from './Login';

interface IProps {

}

interface IState {
    isLoading: boolean;
    isLogin: boolean;
}

export default class Boot extends Component<IProps, IState> {
    state: IState;
    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: true,
            isLogin: !!AdminAPI.getToken()
        };
    }
    async componentDidMount() {
        AdminAPI.addFailedTokenValidationListener(this.onTokenFailed);
        this.setState({
            isLoading: false
        });
    }

    onSuccess = () => {
        this.setState({
            isLogin: true
        })
    }

    onTokenFailed = () => {
        this.setState({
            isLoading: false,
            isLogin: false
        })
    }

    render() {
        if (this.state.isLoading) {
            return <Loading />;
        }
        if (this.state.isLogin) {
            return <Launch />;
        }
        return <Login onSuccess={this.onSuccess} />

    }
}

